import React, { useEffect, useState, useCallback } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './pages/Layout';
import Table from './pages/Table';
import './App.css';

function App() {
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    const standalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;

    setIsStandalone(standalone);
  }, []);

  const handleScan = useCallback((tableId) => {
    if (tableId) {
      console.log('Setting tableId in localStorage:', tableId);
      localStorage.setItem('scannedTableId', tableId);
    }
  }, []);

  return (
    <div className={`App ${isStandalone ? 'standalone' : ''}`}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />} />
          <Route
            path="/tables/:tableId"
            element={<Table handleScan={handleScan} />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;